document.addEventListener("DOMContentLoaded", () => {
    window.InitSlider('.blogslider.swiper', {
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 32
            },
            600: {
                slidesPerView: 1.5,
                spaceBetween: 32
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 48
            },
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 48
            },
            1280: {
                slidesPerView: 2.85,
                spaceBetween: 48
            },
            1600: {
                slidesPerView: 2.85,
                spaceBetween: 64
            }
        }
    });
    window.InitSlider('.cardslider .swiper', {
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 32
            },
            600: {
                slidesPerView: 1.5,
                spaceBetween: 32
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 48
            },
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 48
            },
            1280: {
                slidesPerView: 2.85,
                spaceBetween: 48
            },
            1600: {
                slidesPerView: 2.85,
                spaceBetween: 64
            }
        }
    });
    window.InitSlider('.hero__slideshow__slider.swiper', {
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            600: {
                slidesPerView: 1.5
            },
            768: {
                slidesPerView: 1.75
            },
            1280: {
                slidesPerView: 1.85
            }
        }
    });
    window.InitSlider('.projectslider .swiper', {
        breakpoints: {
            0: {
                slidesPerView: 1.2
            },
            600: {
                slidesPerView: 1.5
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 40
            },
            1024: {
                slidesPerView: 3.5
            },
            1280: {
                slidesPerView: 3.6,
                spaceBetween: 48
            },
            1600: {
                slidesPerView: 3.6,
                spaceBetween: 54
            }
        }
    });
    window.InitSlider('.reviews__slider.swiper', {
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 30
            },
            600: {
                slidesPerView: 1.5
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 48
            },
            1280: {
                slidesPerView: 2.15,
                spaceBetween: 64
            },
            1600: {
                slidesPerView: 2.25,
                spaceBetween: 90
            }
        }
    });
});
